"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prompt = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var mobx_2 = require("mobx");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var PromptLayout_1 = require("./PromptLayout");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var Prompt = (function (_super) {
    __extends(Prompt, _super);
    function Prompt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function (event) {
            _this.props.onDismiss();
            event.stopPropagation();
        };
        return _this;
    }
    Prompt.prototype.componentDidMount = function () {
        var _this = this;
        if (this.show) {
            this.props.onShow();
        }
        else {
            this.disposer = (0, mobx_1.observe)(this.props.useHistoryDataStore, this.props.useHistoryFieldName, function (_a) {
                var newValue = _a.newValue, oldValue = _a.oldValue;
                if (newValue && newValue !== oldValue) {
                    _this.props.onShow();
                }
            });
        }
    };
    Prompt.prototype.componentWillUnmount = function () {
        this.disposer && this.disposer();
    };
    Prompt.prototype.render = function () {
        var _this = this;
        var _a = this.props, top = _a.top, left = _a.left, id = _a.id, className = _a.className, position = _a.position, heading = _a.heading, body = _a.body;
        return (react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: this.show, timeout: kaleidoscope_3.AnimationDuration.Medium }, function (status) { return (react_1.default.createElement(kaleidoscope_1.TooltipElement, { id: id, style: {
                top: top,
                left: left,
            }, position: position, className: (0, classnames_1.default)("prompt", "prompt--".concat(id), className, tokens_1.darkTheme), size: kaleidoscope_1.TooltipSize.Large, transitionStatus: status },
            react_1.default.createElement(PromptLayout_1.PromptLayout, { heading: heading, button: react_1.default.createElement(kaleidoscope_2.Button, { type: kaleidoscope_2.ButtonType.Secondary, size: kaleidoscope_2.ButtonSize.XSmall, onClick: _this.onDismiss }, "Dismiss"), content: body }),
            react_1.default.createElement("div", { className: "prompt__dot" }))); }));
    };
    Object.defineProperty(Prompt.prototype, "show", {
        get: function () {
            return this.props.useHistoryDataStore[this.props.useHistoryFieldName];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_2.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Prompt.prototype, "show", null);
    Prompt = __decorate([
        mobx_react_1.observer
    ], Prompt);
    return Prompt;
}(react_1.default.Component));
exports.Prompt = Prompt;
